import Header from '../components/Header'
import Hero from '../components/Hero'
import Services from '../components/Services'
import Testimonials from '../components/Testimonials'
import CTA from '../components/CTA'
import NewsletterSubscription from '../components/NewsletterSubscription'
import BlogPosts from '../components/BlogPosts'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Services />
        <BlogPosts />
        {/* BlogPosts section moved before Testimonials */}
        <Testimonials />
        <NewsletterSubscription />
        {/* Testimonials section moved after Newsletter Subscription */}
        <CTA />
      </main>
      <Footer />
    </div>
  )
}

export default Home